import React from "react";
import StyledText from "ae-base/Base/StyledText";
import ItemView from "./ItemView";

export default function TextItem(props) {
	var schema = props.schema;
	var content = props.content;
	var screen = props.screen;

	return (
		<ItemView schema={schema} screen={screen} >
			<StyledText>{content}</StyledText>
		</ItemView>
	);
}
